module.exports = __webpack_public_path__ + "static/media/reportcenter.e2fa2a85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mainmenus/reportcenter.png
// module id = 2931
// module chunks = 0